import { createAsyncThunk } from "@reduxjs/toolkit";
import {axios} from '../../common'
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const ANNOUNCEMENT_USER_SHOW = "announcementUser/show";
const ANNOUNCEMENT_BY_USER_SHOW = "announcementUser/showByUser";
const ANNOUNCEMENT_USER_CREATE = "announcementUser/create";

export const showAnnouncementUser = createAsyncThunk(
  ANNOUNCEMENT_USER_SHOW,
  async (payload, thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}AnnouncementUser`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["User,Announcement"],
        filter:
          payload.length > 0 ? ["Announcement/Oid eq " + payload + ""] : [],
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showAnnouncementByUser = createAsyncThunk(
  ANNOUNCEMENT_BY_USER_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.get("AnnouncementUser", {
        params: {
          $expand: "User,Announcement",
          $filter: "User/UserName eq '" + payload + "'",
        },
      });
      return data.value;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const createAnnouncementUser = createAsyncThunk(
  ANNOUNCEMENT_USER_CREATE,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post("AnnouncementUser", payload);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
